// extracted by mini-css-extract-plugin
export var deleteModal = "_j6-0";